import { LoadingCircle } from "../common";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "../../utils/formatPrice";
import CheckVerifiedIcon from "../../assets/check-verified.svg";
import { getSavingsDetails } from "../../services/homeGoal";
import { convertToFormattedAmount } from "../../utils/convertAmount";

const HomeBuyingPower = () => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const [affordability, setAffordability] = useState<number | null>(null);

	useEffect(() => {
		async function fetchSavings() {
			try {
				setIsLoading(true);
				const savingsDetails = await getSavingsDetails();
				setAffordability(savingsDetails.affordability.amount);
				setIsLoading(false);
			} catch (error) {
				setIsLoading(false);
				console.error("Error fetching savings details:", error);
			}
		}
		fetchSavings();
	}, []);

	return (
		<div className="flex flex-col items-center justify-center h-full w-full text-black px-4 space-y-10">
			{isLoading ? (
				<LoadingCircle />
			) : (
				<>
					<div className="space-y-6 w-full">
						<div className="text-3xl font-bold">
							Your Instant Home Buying Power Is:
						</div>
						<div className="text-white font-bold text-5xl rounded-[10px] bg-z-dark-moss-green px-4 py-2 w-fit">
							{affordability
								? `$${formatPrice(convertToFormattedAmount(affordability))}*`
								: "N/A"}
						</div>
					</div>
					<div className="text-xl">
						Based on your current finances, this is what you could afford today.
						<br />
						<br />
						Let's set up your home savings goal.
					</div>
					<button
						type="button"
						onClick={() => {
							window
								._sendEvent("ZownCaAppSavingsStartGoal")
								.catch((error: unknown) => {
									console.error(error);
								})
								.finally(() => {
									navigate("/savings-input-flow/city-selection");
								});
						}}
						className="flex items-center gap-2 justify-center bg-black text-white font-medium rounded-full py-3 w-full mt-4 active:opacity-70"
					>
						<img src={CheckVerifiedIcon} alt="" />
						Set Your Home Goal
					</button>
				</>
			)}
		</div>
	);
};

export { HomeBuyingPower };
